<template id='content'>
	<div class="bg">
		<div class="top">
			<div class="top_c">
				<div>找回密码</div>
			</div>
		</div>
		<div class="bottom">
			<div class="b_t">找回密码</div>
			<div class="b_c">
				<div class="clearfix">
					<div class="b_c_1" v-for="(stepitem,idx) in steplist" :key="idx">
						<div class="b_c_1_bg" :class="{background:idx==step,background1:idx<step}"></div>
						<div class="b_c_1_c" :class="{background:idx==step,background1:idx<step}">{{stepitem.id+1}}</div>
						<div class="b_c_1_t" :class="{color:idx==0,color1:idx<step}">{{stepitem.text}}</div>
					</div>
				</div>
			</div>
			<div>
				<ul class="ul2">
					<li class="clearfix">
						<span class="fl t">请选择验证身份方式：</span>
						<select class="fl" name="" id="">
							<option value="已验证手机">已验证手机</option>
						</select>
					</li>
					<li class="clearfix">
						<span class="fl t">昵称：</span>
						<span class="fl t1">{{member0bj.name}}</span>
					</li>
					<li class="clearfix">
						<span class="fl t">已验证手机：</span>
						<span class="fl t1">{{member0bj.phone}}</span>
					</li>
					<li class="clearfix">
						<span class="fl t">请填写手机效验码：</span>
						<input class="fl code"  v-model="code" type="text">
						<input class="fl getcode" type="button" @click="getcode" :value="time?'重新发送（'+time+'）':'获取手机验证码'">
					</li>
					<li class="clearfix">
						<input class="btn fl" @click="spet2" type="button" value="提交">
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import Qs from 'qs'
	import { ip,sha1 } from '../../assets/js/public.js'
  import bus from '../../assets/js/eventBus'

	export default {
		data () {
			return {
				steplist:[{'id':0,'text':'填写账户名'},{'id':1,'text':'验证身份'},{'id':2,'text':'设置新密码'},{'id':3,'text':'完成'}],
				isGetCode:false,
				time:0,
				member0bj:{},
				code:'',
				step:null
			}
		},
		mounted:function () {
			var t_=this
			t_.step=t_.$route.query.step-1
			if(!localStorage.member0bj)return this.$message({
				message:'超时了，请从第一步开始哦~！',
				center:true,
				type:'warning'
			})
			t_.member0bj=JSON.parse(localStorage.member0bj)
		},
		methods:{
			spet2:function(){
				var t_=this
				if(!t_.code)return this.$message({
					message:'请填写验证码',
					center:true,
					type:'warning'
				})
				var data0bj = Qs.stringify({
					mobile:t_.member0bj.phone,
					verifyCode:t_.code
				})
				axios.post(
					`${ip}formWorkInterface/validationCode`,data0bj
				).then( res => {
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}
					if(res.data.message!='success')return this.$message({
					message:'验证码错误',
					center:true,
					type:'warning'
					})
					this.$router.push({path: '/setPassword3',query:{ step:3}});
				} )
			},
			getcode:function(){
				var t_=this
				t_.isGetCode=true
				var data0bj = Qs.stringify({
					mobilePhone:t_.member0bj.phone
				})
				axios.post(
					`${ip}formWorkInterface/WxCode`,data0bj
				).then( res => {
					if(res.data.code==300){
						var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
						return window.open(href.href,'_blank')
					}
					if(res.data.code==1){
						t_.time=60
						t_.countDown()
					}
					if(res.data.code==2){
						this.$message({
							message:res.data.message,
							center:true,
							type:'warning'
						})
					}
				} )
			},
			countDown:function(){
				var t_=this
				var fn=function(){
					setTimeout(function(){
						t_.time=--t_.time
						if(t_.time>0){
							fn()
						}
					},1000,t_)
				}
				fn()
			},
		}
	}
</script>

<style>
	html,body{
    height: 100%;
  }
	.clearfix {
		overflow: auto;
		_height: 1%;
	}
	.fl{
		float: left;
	}
	.bg{
		background: #f5f5f5;
		height: 100%;
	}
	.top{
		background: #fff;
		height: 116px;
		border-bottom: 3px solid #ff2c4c;
	}
	.top_c{
		width: 990px;
		height: 116px;
		margin: 0 auto;
	}
	.top_c div{
		font-size: 24px;
		color:#2d2d2d;
		margin-left: 20px;
		line-height: 96px;
	}
	.bottom{
		width: 990px;
		height: 530px;
		background: #fff;
		margin: 0 auto;
	}
	.b_t{
		height: 44px;
		padding: 24px 0 0 21px;
		color:#666;
		font-weight: 900;
	}
	.b_c{
		width: 634px;
		margin: 0 auto;
		overflow: hidden;
	}
	.b_c_1{
		width: 25%;
		height: 40px;
		position: relative;
		float: left;
		overflow: hidden;
	}
	.b_c_1_bg{
		width: 100%;
		height: 5px;
		background: #cdcdcd;
		position: absolute;
		top: 10px;
	}
	.b_c_1_c{
		width: 23px;
		height: 23px;
		border-radius: 50%;
		background: #cdcdcd;
		color: #fff;
		text-align: center;
		line-height: 23px;
		margin: 0 auto;
		position: relative;
	}
	.b_c_1_t{
		color:#666;
		text-align: center;
		margin-top: 1px;
	}
	.background{
		background: #7abd54;
	}
	.color{
		color:#7abd54;
	}
	.color1{
		color:#7abd54;
	}
	.background1{
		background:#cbedb7;
	}
	.bottom .ul2{
		margin-top: 44px;
		margin-left: 315px;
	}
	.bottom .ul2 .t{
		width: 140px;
		text-align: right;
		line-height: 30px;
	}
	.bottom .ul2 li{
		margin-bottom: 20px;
	}
	.bottom .ul2 select{
		width: 185px;
		height: 30px;
	}
	.bottom .ul2 .t1{
		line-height: 30px;
		font-weight: 900;
	}
	.bottom .ul2 .code{
		width: 150px;
		height: 34px;
		background:#fff;
		border: 1px solid #cdcdcd;
		padding-left: 5px;
	}
	.bottom .ul2 .getcode{
		width: 128px;
		height: 36px;
		border-radius: 10px;
		border: 1px solid #bfbebf;
		color: #de2c3a;
		background: #fff;
		margin-left: 20px;
	}
	.bottom .ul2 .btn{
		width: 62px;
		height: 32px;
		border: 0;
		border-radius: 7px;
		color:#fff;
		background: #de2c3a;
		margin-left: 139px;
	}
</style>


// WEBPACK FOOTER //
// src/components/setPassword/setPWD2.vue